import appConstants from "../../../../../appConstants";
export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
    static getConfiguration({featureFlags}) {
      return GridConfig.getDefaultConfiguration( featureFlags);
    }

    static getDefaultConfiguration(featureFlags) {
    return {
      title: appConstants.gridNames.TrailerInventory,
      keyColumn: "trailerName",
      defaultColDef: {
        sortable: false,
        resizable: false,
      },
      columns: [
        {
          headerName: "Trailer ID",
          field: "trailerId",
          hide: true,
          headerTooltip: "Trailer ID"
        },
        {
          headerName: "Trailer Type",
          field: "trailerName",
          headerTooltip: "Trailer Type",
          minWidth:200
        },
        {
          headerName: "Max PSE",
          field: "maxSkidsAllowed",
          headerTooltip: "Max Skids Allowed",
          hide: featureFlags.IsWeightBasedRoutingEnabled
        },
        {
          headerName: "Max Weight",
          field: "maxWeight",
          headerTooltip: "Max Weight",
          hide: !featureFlags.IsWeightBasedRoutingEnabled
        },
        {
          headerName: "Available Count",
          field: "totalCount",
          headerTooltip: "Available Count",
        },
         {
          headerName: "Lift Gate",
          field: "isLiftGateRequired",
          headerTooltip: "Lift Gate",
        },
        {
          headerName: "2 Man",
          field: "isTwoManService",
          headerTooltip: "2 Man",
          hide: !featureFlags.shouldShowTwoManInTrailerInventory
        }
      ]
    }
  }
}
